<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link tag="a" to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo/logo-white.svg" alt width="65" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo/logo-white.svg" alt width="130" />
            </span>
          </router-link>

          <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo/logo-white.svg" alt width="65" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo/logo-white.svg" alt width="130" />
            </span>
          </router-link>
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>
      </div>

      <div class="d-flex">
        <a href="/tasks/create">
          <button class="btn btn-primary m-3">{{ $t('menuitems.tasks.list.create-task') }}</button>
        </a>

        <b-dropdown variant="white" right toggle-class="header-item">
          <template v-slot:button-content>
            <img class :src="currentLocaleFlag" alt="Header Language" height="16" />
          </template>
          <b-dropdown-item
            class="notify-item"
            v-for="(entry, i) in languages"
            :key="`Lang${i}`"
            :value="entry"
            @click="setLanguage(entry.language)"
          >
            <img :src="`${entry.flag}`" alt="user-image" class="mr-1" height="12" />
            <span class="align-middle">{{ entry.title }}</span>
          </b-dropdown-item>
        </b-dropdown>

        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <i class="fa fa-cog" aria-hidden="true"></i>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <b-dropdown-item class="top-bar--username__label">
            <span>
              <i class="fa fa-user-circle" aria-hidden="true"></i>
              {{ getUsername() }}
            </span>
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item>
            <a @click="changePassword(currentUser.username)">
              <i class="fa fa-key font-size-16 align-middle mr-1" aria-hidden="true"></i>
              {{ $t('change-password.menu-text') }}
            </a>
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <a href="/logout" class="dropdown-item text-danger">
            <i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>
            {{ $t('navbar.dropdown.profile.list.logout') }}
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>

<script>
import i18n from "@/i18n";
import { authService } from '@/helpers/services/auth/authService';

/**
 * Nav-bar Component
 */
export default {
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/en.jpg"),
          language: "en",
          title: "English"
        },
        {
          flag: require("@/assets/images/flags/de.jpg"),
          language: "de",
          title: "Deutsch"
        }
      ],
      currentLocaleFlag: "",
      currentUser: {},
    };
  },
  methods: {
    getUsername() {
      const lastName = this.currentUser.lastName;
      const firstName = this.currentUser.firstName;

      if (!lastName || !firstName) {
        return "";
      }

      return `${lastName}, ${firstName}`;
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    setLanguage(locale) {
      i18n.locale = locale;
      authService.setUserLocale(locale);
      this.setCurrentLocaleFlag(locale);
    },
    setCurrentLocaleFlag(locale) {
      if (!locale) {
        this.currentLocaleFlag = require(`@/assets/images/flags/en.jpg`);
      } else {
        this.currentLocaleFlag = require(`@/assets/images/flags/${locale}.jpg`);
      }
    },
    changePassword(username) {
      authService.changePasswordViaModal(username);
    },
  },
  computed: {
  },
  created() {
    this.setCurrentLocaleFlag(authService.getUserLocale());
    this.currentUser = authService.getUser();
  }
};
</script>

<style lang="scss" scoped>
  .top-bar--username__label {
    text-align: center;
    cursor: default;
  }
</style>